import { render } from "./VenueSelectCourier.vue?vue&type=template&id=24f8678b"
import script from "./VenueSelectCourier.vue?vue&type=script&lang=js"
export * from "./VenueSelectCourier.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/checkout/VenueSelectCourier.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24f8678b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24f8678b', __exports__)) {
    api.reload('24f8678b', __exports__)
  }
  
  module.hot.accept("./VenueSelectCourier.vue?vue&type=template&id=24f8678b", () => {
    api.rerender('24f8678b', render)
  })

}


export default __exports__